import { Button } from 'antd';
import Confirm from 'common/components/confirm.component';
import { OrderTranscription } from 'config/constants/transcription.constant';
import React from 'react';

type DiscardMiniCartProps = {
  onConfirm: () => void | Promise<void>;
};

const DiscardMiniCart: React.FC<DiscardMiniCartProps> = ({ onConfirm }) => {
  return (
    <Confirm
      placement='top'
      title={OrderTranscription.DISCARD_CART}
      description={OrderTranscription.DISCARD_CART_CONFIRMATION}
      onConfirm={onConfirm}
      key={OrderTranscription.DISCARD_CART}
    >
      <Button type='link'>{OrderTranscription.DISCARD_CART}</Button>
    </Confirm>
  );
};

export default DiscardMiniCart;
